import { useQuery } from "@tanstack/react-query";
import {
  CareerMatches,
  MyMatches,
  NearMeMatches,
  ProfessionalMatches,
  ProfileMayLike,
  RecentlyViewed,
} from "api/explore";

export const useMyMatches = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["myMatches", { page, limit, see_all, filter_data }],
    queryFn: MyMatches,
    ...options,
  });
};

export const useRecentlyViewed = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["recentlyViewed", { page, limit, see_all, filter_data }],
    queryFn: RecentlyViewed,
    ...options,
  });
};

export const useCareerMatches = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["careerMatches", { page, limit, see_all, filter_data }],
    queryFn: CareerMatches,
    ...options,
  });
};

export const useProfessionalMatches = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["professionalMatches", { page, limit, see_all, filter_data }],
    queryFn: ProfessionalMatches,
    ...options,
  });
};

export const useProfileMayLike = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["profileMayLike", { page, limit, see_all, filter_data }],
    queryFn: ProfileMayLike,
    ...options,
  });
};

export const useNearMeMatches = (
  { page, limit, see_all, filter_data },
  options = {},
) => {
  return useQuery({
    queryKey: ["nearMeMatches", { page, limit, see_all, filter_data }],
    queryFn: NearMeMatches,
    ...options,
  });
};
